import { Button, ButtonProps } from '@mui/material';

const BaseButton = ({ children, sx, ...rest }: ButtonProps) => (
  <Button variant="contained" sx={{ m: 1, ...sx }} {...rest}>
    {children}
  </Button>
);

export { BaseButton as Button };
